import React from "react";

export default function Team() {
  return (
    <>
      <section className="team" id="team">
        <h1 className="heading">our team</h1>
        <div className="box-container">
          <div className="box">
            <img src={"./images/team1.jpg"} />
            <div className="info">
              <h3>john deo</h3>
              <p>web designer</p>
              <div className="share">
                <a href="#" className="fa fa-facebook-f" />
                <a href="#" className="fa fa-twitter" />
                <a href="#" className="fa fa-instagram" />
                <a href="#" className="fa fa-linkedin" />{" "}
              </div>
            </div>
          </div>
          <div className="box">
            <img src={"./images/team2.jpg"} />
            <div className="info">
              <h3>john deo</h3>
              <p>web designer</p>
              <div className="share">
                <a href="#" className="fa fa-facebook-f" />
                <a href="#" className="fa fa-twitter" />
                <a href="#" className="fa fa-instagram" />
                <a href="#" className="fa fa-linkedin" />
              </div>
            </div>
          </div>
          <div className="box">
            <img src={"./images/team3.jpg"} />
            <div className="info">
              <h3>john deo</h3>
              <p>web designer</p>
              <div className="share">
                <a href="#" className="fa fa-facebook-f" />
                <a href="#" className="fa fa-twitter" />
                <a href="#" className="fa fa-instagram" />
                <a href="#" className="fa fa-linkedin" />
              </div>
            </div>
          </div>
          <div className="box">
            <img src={"images/team4.jpg"} alt="" />
            <div className="info">
              <h3>john deo</h3>
              <p>web designer</p>
              <div className="share">
                <a href="#" className="fa fa-facebook-f" />
                <a href="#" className="fa fa-twitter" />
                <a href="#" className="fa fa-instagram" />
                <a href="#" className="fa fa-linkedin" />
              </div>
            </div>
          </div>
          <div className="box">
            <img src={"images/team5.jpg"} alt="" />
            <div className="info">
              <h3>john deo</h3>
              <p>web designer</p>
              <div className="share">
                <a href="#" className="fa fa-facebook-f" />
                <a href="#" className="fa fa-twitter" />
                <a href="#" className="fa fa-instagram" />
                <a href="#" className="fa fa-linkedin" />
              </div>
            </div>
          </div>
          <div className="box">
            <img src={"images/team6.jpg"} alt="" />
            <div className="info">
              <h3>john deo</h3>
              <p>web designer</p>
              <div className="share">
                <a href="#" className="fa fa-facebook-f" />
                <a href="#" className="fa fa-twitter" />
                <a href="#" className="fa fa-instagram" />
                <a href="#" className="fa fa-linkedin" />
              </div>
            </div>
          </div>
          <div className="box">
            <img src={"images/team7.jpg"} alt="" />
            <div className="info">
              <h3>john deo</h3>
              <p>web designer</p>
              <div className="share">
                <a href="#" className="fa fa-facebook-f" />
                <a href="#" className="fa fa-twitter" />
                <a href="#" className="fa fa-instagram" />
                <a href="#" className="fa fa-linkedin" />
              </div>
            </div>
          </div>
          <div className="box">
            <img src={"images/team8.jpg"} alt="" />
            <div className="info">
              <h3>john deo</h3>
              <p>web designer</p>
              <div className="share">
                <a href="#" className="fa fa-facebook-f" />
                <a href="#" className="fa fa-twitter" />
                <a href="#" className="fa fa-instagram" />
                <a href="#" className="fa fa-linkedin" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
